export const APP_DOWNLOAD_URL = 'https://apps.apple.com/us/app/figs/id1503374453'
